import "./spinner-styles.scss";

function Spinner() {
  return (
    <div className="spinner">
      <div className="spinner__container" />
    </div>
  );
}

export default Spinner;
